import React, { useState, useMemo } from 'react'
import { Table, Button, Icon } from 'antd'
import moment from 'moment'
import { Map, TileLayer, GeoJSON, Marker, Tooltip } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import { geojsonIndia } from '../../util/methods'
import GeoJSONLabels from '../../components/GeoJSONLabels/GeoJSONLabels'
import { getLeafletTileConfig } from '../../util/mapTiles'

const greenDrivingIconUrls = {
  1: require('assets/images/icon/acceleration.png'),
  2: require('assets/images/icon/brake.png'),
  3: require('assets/images/icon/turning.png')
}

function parseLatLong(latLong) {
  if (!latLong || typeof latLong !== 'string') return null
  const parts = latLong.split(',').map(s => parseFloat(s.trim()))
  if (parts.length !== 2 || isNaN(parts[0]) || isNaN(parts[1])) return null
  return [parts[0], parts[1]]
}

function GreenDrivingEventsModal({ events = [], eventTypeLabel = 'Event', eventTypeKey = 1 }) {
  const tileLayerConfig = getLeafletTileConfig()
  const [isMapView, setIsMapView] = useState(false)
  const [isSingleMapView, setIsSingleMapView] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [zoom, setZoom] = useState(18)

  const normalizedEvents = useMemo(() => {
    return events.map((evt, index) => ({
      ...evt,
      key: `${evt.timestamp}-${index}`,
      location: evt.lat_long || '',
      position: parseLatLong(evt.lat_long)
    })).filter(evt => evt.timestamp != null)
  }, [events])

  const mapVisibleEvents = selectedRecord ? [selectedRecord] : normalizedEvents.filter(evt => evt.position != null)
  const mapCenter = useMemo(() => {
    if (mapVisibleEvents.length === 0) return [20.5937, 78.9629]
    const first = mapVisibleEvents[0]
    return first.position || [20.5937, 78.9629]
  }, [mapVisibleEvents])

  const handleZoomChange = () => {
    const mapElement = document.querySelector('.leaflet-container')
    if (mapElement && mapElement._leaflet_map) {
      setZoom(mapElement._leaflet_map.getZoom())
    }
  }

  const columns = [
    {
      title: 'Time',
      dataIndex: 'timestamp',
      key: 'timestamp',
      sorter: (a, b) => (a.timestamp || 0) - (b.timestamp || 0),
      render: (text) => text != null ? moment(text).format('DD/MM/YYYY HH:mm:ss') : '-'
    },
    // {
    //   title: 'Location',
    //   dataIndex: 'location',
    //   key: 'location',
    //   sorter: (a, b) => a.location.localeCompare(b.location),
    //   render: (text, record) => (
    //     record.position ? (
    //       <Icon
    //         type="environment"
    //         style={{ fontSize: '16px', cursor: 'pointer', color: '#1890ff' }}
    //         onClick={() => {
    //           setSelectedRecord(record)
    //           setIsMapView(true)
    //           setIsSingleMapView(true)
    //         }}
    //       />
    //     ) : null
    //   )
    // },
    {
      title: 'Map',
      key: 'map',
      render: (_, record) => (
        record.position ? (
          <Icon
            type="environment"
            style={{ fontSize: '16px', cursor: 'pointer', color: '#1890ff' }}
            onClick={() => {
              setSelectedRecord(record)
              setIsMapView(true)
              setIsSingleMapView(true)
            }}
          />
        ) : null
      )
    }
  ]

  const renderMap = () => (
    <div style={{ height: '600px' }}>
      <Map
        key={selectedRecord ? selectedRecord.key : 'all'}
        center={mapCenter}
        zoom={selectedRecord ? 15 : 12}
        maxZoom={tileLayerConfig.maxZoom || 18}
        attributionControl={false}
        style={{ height: '100%' }}
        onZoomend={handleZoomChange}
      >
        <TileLayer
          url={tileLayerConfig.url}
          subdomains={tileLayerConfig.subdomains}
        />
        <GeoJSON data={geojsonIndia} style={{ color: 'grey', weight: 1 }} />
        <GeoJSONLabels zoom={zoom} minZoomLevel={17} />
        {mapVisibleEvents.map((item) => {
          const iconUrl = greenDrivingIconUrls[eventTypeKey] || greenDrivingIconUrls[1]
          const markerIcon = L.divIcon({
            className: 'green-driving-marker',
            html: `<img src="${iconUrl}" alt="" style="width:24px;height:24px;" />`,
            iconSize: [24, 24],
            iconAnchor: [12, 12]
          })
          return (
            <Marker
              key={item.key}
              position={item.position}
              icon={markerIcon}
            >
              <Tooltip permanent={false} direction="top">
                <span>{item.timestamp != null ? moment(item.timestamp).format('DD/MM/YYYY HH:mm:ss') : '-'}</span>
              </Tooltip>
            </Marker>
          )
        })}
      </Map>
    </div>
  )

  const renderTable = () => (
    <Table
      dataSource={[...normalizedEvents].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))}
      columns={columns}
      pagination={{ pageSize: 10 }}
      rowKey="key"
    />
  )

  if (normalizedEvents.length === 0) {
    return <p className="gx-mb-0">No events recorded.</p>
  }

  return (
    <>
      {isMapView ? renderMap() : renderTable()}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
        <Button
          type="primary"
          onClick={() => {
            setIsMapView(!isMapView)
            setSelectedRecord(null)
            setIsSingleMapView(false)
          }}
          size="small"
        >
          Switch to {isMapView ? 'Table' : 'Map'} View
        </Button>
        <span style={{ fontWeight: 'bold' }}>
          Total: {normalizedEvents.length} event(s)
        </span>
      </div>
    </>
  )
}

export default GreenDrivingEventsModal
